import type { Messages } from '../types';

const en: Messages = {
  'meta.homeTitle': 'Free Printable Calendar Online - Calendarify',
  'meta.homeDescription':
    'Free printable calendars online. Choose any month, customize your layout, and print your calendar for free with Calendarify — no signup required.',
  'meta.twitterTitle': 'Free Printable Calendar Online - Calendarify',
  'meta.twitterDescription':
    'Free printable calendars online. Customize a monthly calendar and print it for free — fast, simple, no download required.',
  'meta.supportTitle': 'Support - Calendarify',
  'meta.supportDescription':
    'Get help with Calendarify: print from mobile, save as PDF, and use calendars on tablets like ReMarkable or BOOX.',
  'meta.printTitle': 'Free Printable Monthly Calendar - Calendarify',
  'meta.printDescription':
    'Print a free monthly calendar online. Customize colors and notes, then print your calendar for free with Calendarify.',
  'meta.printMonthTitle': '{month} {year} Printable Calendar - Calendarify',
  'meta.printMonthDescription':
    'Free printable {month} {year} calendar online. Customize colors, add notes, and print your monthly calendar for free.',

  'header.subtitle': 'Free printable calendars online',
  'nav.home': 'Home',
  'nav.support': 'Support',
  'nav.menu': 'Menu',
  'nav.language': 'Language',

  'footer.rights': 'All rights reserved.',

  'home.intro':
    'Pick a month below, customize how it looks, and print your calendar for free — no signup, no app download.',
  'home.customMonth': 'Custom Month',
  'home.go': 'Go',

  'print.tip':
    'Click "Configure" to change how your calendar looks. You can see a preview of the calendar at the bottom of this page. Remember, you can also click on any day in the calendar preview to add your own text into it to be printed out.',
  'print.invalidUrl': 'Invalid calendar URL',
  'print.h1Fallback': 'Print a Calendar - Free Printable Monthly Calendar',
  'print.monthHeading': '{month} {year} Printable Calendar',

  'printer.configure': 'Configure',
  'printer.printCalendar': 'Print Calendar',
  'printer.theme': 'Theme',
  'printer.grid': 'Grid',
  'printer.gridStyle': 'Grid style:',
  'printer.lineWidth': 'Line width (px):',
  'printer.lineColor': 'Line color:',
  'printer.fontColor': 'Font color:',
  'printer.weekend': 'Weekend:',
  'printer.holiday': 'Holiday:',
  'printer.weekStartsOn': 'Week starts on:',
  'printer.showCountryHolidays': 'Show country holidays:',
  'printer.showSidebar': 'Show sidebar area:',
  'printer.showFootnotes': 'Show footnotes area:',
  'printer.sideNotes': 'Side Notes',
  'printer.footnotes': 'Footnotes',
  'printer.gridRectangle': 'Rectangle',
  'printer.gridRounded': 'Rounded',
  'printer.gridMinimal': 'Minimal',
  'printer.monday': 'Monday',
  'printer.sunday': 'Sunday',
  'printer.none': 'None',
  'printer.canada': 'Canada',
  'printer.mexico': 'Mexico',
  'printer.uk': 'UK',
  'printer.usa': 'USA',

  'support.intro':
    'Thank you for using Calendarify. If there is any additional feature that would help you with your calendar needs, we\'d like to know.',
  'support.cta': 'Please send your idea to:',
  'support.faqHeading': 'Frequently Asked Questions',
  'support.qMobile': 'Can I print from a mobile device?',
  'support.aMobile':
    'Yes, although some devices don\'t render the calendar size correctly. Usually in this case you can adjust the "scale" in the print preview dialog to make everything fit on one page.',
  'support.qPdf': 'Can I save the calendar as a PDF?',
  'support.aPdf':
    'Yes, you can usually do it by clicking "Print" and then choosing "Print to PDF" in the print preview dialog.',
  'support.qTablet': 'Can I use these calendars on my ReMarkable, BOOX, or another tablet?',
  'support.aTablet':
    'Absolutely, just Print as PDF and upload that PDF file to your tablet (for ReMarkable you can upload files via their website, for example, for other devices you can use a file share like Google Drive).',

  'months.january': 'January',
  'months.february': 'February',
  'months.march': 'March',
  'months.april': 'April',
  'months.may': 'May',
  'months.june': 'June',
  'months.july': 'July',
  'months.august': 'August',
  'months.september': 'September',
  'months.october': 'October',
  'months.november': 'November',
  'months.december': 'December',

  'weekdays.sun': 'Sun',
  'weekdays.mon': 'Mon',
  'weekdays.tue': 'Tue',
  'weekdays.wed': 'Wed',
  'weekdays.thu': 'Thu',
  'weekdays.fri': 'Fri',
  'weekdays.sat': 'Sat',
};

export default en;
